export { getEnumKeyByEnumValue, filterPropsToThoseOnType, logFriendlyObject } from './dataStructures/objectUtils';
export { capitalizeFirstLetter } from './dataStructures/stringUtils';
export { shuffle } from './dataStructures/arrayUtils';

export {
    setEnvironment,
    getConfigValue,
    getConfigNumber,
    getConfigString,
    getConfigBoolean,
    getFlagValue,
} from './environment/environmentUtils';
